module.exports = __webpack_public_path__ + "static/media/header-desk-bg.b16ba3a7.bin";